import type { CXPublicSurveySubmissionResponse } from './cxPublicSurveyService';

// HTTP success alone is not an acknowledgement of a durable customer response.
export function assertSurveyAcknowledgement(
  response: CXPublicSurveySubmissionResponse,
  testMode: boolean
): void {
  const valid = testMode
    ? response?.status === 'test_completed' &&
      response.testMode === true &&
      response.persisted === false &&
      response.ratingId === 0 &&
      response.appointmentId === 0
    : response?.status === 'completed' &&
      (response.testMode === undefined || response.testMode === false) &&
      (response.persisted === undefined || response.persisted === true) &&
      Number.isSafeInteger(response.ratingId) &&
      response.ratingId > 0 &&
      Number.isSafeInteger(response.appointmentId) &&
      response.appointmentId > 0;
  if (!valid)
    throw new Error('The server did not acknowledge this survey response. Please try again.');
}
